import React, { useContext } from "react";
import "./styles/module.css";
import { NavLink, useParams } from "react-router-dom";
import { GlobalContext } from "../../context/GlobalState";
import { image, fixName } from "../helpers";

import { fileType, actionType, getModuleType } from "./util";

const CardStyle = (thumbnail) => ({
  backgroundImage: thumbnail
    ? `url(${thumbnail})`
    : `url(${process.env.PUBLIC_URL + "/backgrounds/modules/pdfImage.png"})`,

  backgroundSize: "cover",
  height: "75%",
  borderRadius: "17px 17px 0px 0px",
});

const Module = ({ modules, fetched, heading, hide }) => {
  const { grade, section } = useContext(GlobalContext).userDetails;
  //Extracting params
  const params = useParams();
  const subject = params.subject;
  const chapter = params.chapter;
  // const topic = params.topic;
  let topicNameString = window.location.href
    .split("/")
    [window.location.href.split("/").length - 1].split("%20");
  const topicName = decodeURIComponent(topicNameString.join(" "));

  //Function to compare the thumbnail and video
  const compare = (file) => {
    if (fileType(file) == "Image") {
      return 1;
    } else {
      return 0;
    }
  };

  //Function to fix the file url based on the content type
  const fixFileUrl = (fileUrl, fileName) => {
    if (!fileUrl.startsWith("https://")) {
      fileUrl = fileUrl.split(" ").join("%20");
      fileUrl = "https://xcell-cms-files.s3.amazonaws.com" + fileUrl;
    }

    fileUrl = removeDoubleSlash(fileUrl);

    if (
      fileType(fileName) == "PowerPoint" ||
      fileType(fileName) == "WordDocument"
    ) {
      return "https://view.officeapps.live.com/op/embed.aspx?src=" + fileUrl;
    } else if (fileType(fileName) === "Document") {
      console.log(fileUrl);
      return `${fileUrl}#toolbar=0`;
    } else {
      return fileUrl;
    }
  };

  //function to remove the double slasshes from url path
  const removeDoubleSlash = (url) => {
    const newUrl = new URL(url);
    if (!newUrl.pathname.includes("//")) return url;
    return `${newUrl.origin}${newUrl.pathname.replace("//", "/")}`;
  };

  //Call the page visit api whenever a module is clicked
  const Visited = async (teacherId, module) => {
    const [localGrade, localSection] = localStorage
      .getItem("userGrade")
      .split("-");
    console.log(localGrade, localSection, 1234);
    await fetch(`${process.env.REACT_APP_ORIGIN}/api/v1/analytics/pagevisits`, {
      method: "POST",
      headers: {
        token: `${window.localStorage.getItem("authToken")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        teacherId,
        subject,
        chapter,
        topic: params?.topic,
        module,
        grade: grade || localGrade,
        section: section || localSection,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
      });
  };

  return (
    <>
      <div
        className="row module my-3 gy-4"
        style={{ display: hide ? "none" : "flex" }}
      >
        {heading && <h4>{heading}</h4>}
        {modules.length > 0 ? (
          modules.map((module) => {
            var result = getModuleType(module.resources);
            return (
              <div
                className="col-sm-2 col-6"
                style={{ display: result.notFound ? "none" : "block" }}
              >
                <NavLink
                  to={{
                    pathname:
                      "/learningresources/modules" +
                      `/${module._id}/media/?subject=${params.subject}&chapter=${params.chapter}&topic=${params.topic}`,
                    useProps: !result.notFound
                      ? {
                          fileUrl: fixFileUrl(
                            result.resource.fileUrl,
                            result.fileType
                          ),
                          viewer: actionType(result.fileType),
                          moduleName: module.name,
                        }
                      : {
                          fileUrl: "",
                          fileName: "",
                        },
                  }}
                  style={{ textDecoration: "none" }}
                >
                  {/* <div className='text-center' style={ModuleStyle}> */}
                  <div className="card card-height card-radius">
                    <div className="card-img">
                      <img
                        src={image(module.thumbnail)}
                        alt={module.name || "module"}
                        className="card-thumbnail"
                      />
                    </div>
                    <div
                      className="text-dark text-center"
                      // style={CardStyle(module.thumbnail)}
                      style={{ fontWeight: "bold" }}
                    >
                      <p
                        className="mar-p"
                        dangerouslySetInnerHTML={{ __html: module.name }}
                      ></p>
                      {/* <p>{fileType(result.fileType)}
                      </p> */}
                    </div>
                  </div>
                </NavLink>
              </div>
            );
          })
        ) : (
          <h5 style={{ textAlign: "center" }}>
            {fetched ? "0 modules to show" : "Loading..."}
          </h5>
        )}
      </div>
    </>
  );
};

export default Module;
